module.exports = __webpack_public_path__ + "img/home_active.f76e83ff.png";